import styled from 'styled-components';

import { Box } from '../layout';

export const StyledCardHeader = styled(Box)(() => ({
  marginTop: 32,
}));
